import { jsPDF } from 'jspdf';
import autoTable from 'jspdf-autotable';
import { formatLocalizedNumber } from './currency';
import { registerDejaVuSansFont } from './pdfFonts/registerPdfFont';

function convertPrice(value, conversionRate) {
  const num = parseFloat(value);
  if (Number.isNaN(num)) {
    return null;
  }
  return num * conversionRate;
}

function formatPdfPriceAmount(value, language) {
  return formatLocalizedNumber(value, language, 2);
}

export async function generatePriceListPdf({
  dresses,
  salonId,
  salonHeading,
  title,
  columns,
  formatDressName,
  targetCurrency,
  conversionRate,
  language,
  validFromText,
}) {
  const doc = new jsPDF({ orientation: 'portrait', unit: 'mm', format: 'a4' });
  await registerDejaVuSansFont(doc);

  const pageWidth = doc.internal.pageSize.getWidth();

  doc.setFontSize(14);
  doc.text(salonHeading, pageWidth / 2, 14, { align: 'center' });
  doc.setFontSize(18);
  doc.text(title, pageWidth / 2, 24, { align: 'center' });

  let tableStartY = 32;
  if (validFromText) {
    doc.setFontSize(9);
    doc.text(validFromText, pageWidth / 2, 31, { align: 'center' });
    tableStartY = 38;
  }

  const body = dresses.map((dress, index) => [
    String(index + 1),
    formatDressName(dress.name || ''),
    dress.item_code || '',
    formatPdfPriceAmount(convertPrice(dress.rental_price, conversionRate), language),
    formatPdfPriceAmount(convertPrice(dress.selling_price, conversionRate), language),
  ]);

  const rentalHeader = `${columns.rentalPrice} (${targetCurrency})`;
  const sellingHeader = `${columns.sellingPrice} (${targetCurrency})`;

  autoTable(doc, {
    startY: tableStartY,
    head: [[
      { content: columns.index, styles: { halign: 'center' } },
      { content: columns.name, styles: { halign: 'left' } },
      { content: columns.itemCode, styles: { halign: 'left' } },
      { content: rentalHeader, styles: { halign: 'right' } },
      { content: sellingHeader, styles: { halign: 'right' } },
    ]],
    body,
    styles: {
      font: 'DejaVuSans',
      fontSize: 10,
      cellPadding: 3,
      overflow: 'linebreak',
    },
    headStyles: {
      font: 'DejaVuSans',
      fontStyle: 'normal',
      fillColor: [248, 249, 250],
      textColor: [51, 51, 51],
      valign: 'middle',
    },
    columnStyles: {
      0: { cellWidth: 15, halign: 'center', overflow: 'visible', minCellWidth: 15 },
      1: { cellWidth: 43 },
      2: { cellWidth: 30 },
      3: { cellWidth: 44, halign: 'right' },
      4: { cellWidth: 44, halign: 'right' },
    },
    didParseCell: (data) => {
      if (data.column.index === 0) {
        data.cell.styles.overflow = 'visible';
        data.cell.styles.cellWidth = 15;
      }
      if (data.section === 'head' && (data.column.index === 3 || data.column.index === 4)) {
        data.cell.styles.halign = 'right';
      }
    },
    margin: { left: 14, right: 14 },
  });

  const date = new Date().toISOString().slice(0, 10);
  doc.save(`price-list-${salonId}-${date}.pdf`);
}
